import axios from 'axios';
import { isNil } from 'lodash';
import { findJWTByProfileId } from '@/helpers/auth';

const instanceRoot = axios.create({
  baseURL: process.env.VUE_APP_PARENT_API,
  timeout: 3 * 60 * 1000,
});

const instanceSchool = axios.create({
  baseURL: process.env.VUE_APP_SCHOOL_API,
  timeout: 3 * 60 * 1000,
});

export function initRequestInterceptors({ store }) {
  instanceRoot.interceptors.request.use(addAuthorizationJWT(store));
  instanceSchool.interceptors.request.use(addAuthorizationJWT(store));
}

function addAuthorizationJWT(store) {
  return function (config) {
    try {
      const activeChildProfileId = store.getters['children/activeChildProfile']?.id;

      if (isNil(config.headers.Authorization) && activeChildProfileId) {
        const jwt = findJWTByProfileId(store.getters, activeChildProfileId);

        if (jwt) {
          config.headers.Authorization = `Bearer ${jwt}`;
        }
      }

      return config;
    } catch (err) {
      console.error(err);
      return config;
    }
  };
}

export const requestRoot = instanceRoot;
export const requestSchool = instanceSchool;
